import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=3d7bdc63&scoped=true"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7bdc63",
  null
  
)

export default component.exports